import staffApiService from '@/services/api/Staff'

const emptyModel = {
  id: null,
  name: null,
  contact_details: {
    email: null,
    phone: null
  },
  user: {
    email: null,
    password: null,
    password_confirmation: null,
    service_allow_bases: [],
    service_allow_countries: [],
    roles: []
  }
}

const emptyFilters = {
  name: null,
  role: null
}

export default class Staff {
  static api = staffApiService
  static emptyModel = emptyModel
  static emptyFilters = emptyFilters
}
